import {Component, OnInit, Input, Output, Renderer2, EventEmitter, ViewChild, ContentChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FormGroup, FormControl, Validators} from '@angular/forms'

@Component({
  selector: 'as-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['../pannels.component.scss']
})
export class ModalComponent implements OnInit {


  @ContentChild('modalForm', {static: true}) modalForm;

  @Input() data: any;
  @Input() url: string;
  @Input() type: string;
  @Input() action: string;
  @Input() title: string;
  @Input() id;
  @Input() size;
  @Input() ajax: boolean = false
  @Input() saveButtonLabel: string;
  @Input() titleBadge
  @Input() icon
  @Input() href

  @Output() outputData = new EventEmitter();
  @Output() formOutputData = new EventEmitter();

  constructor(
    private http: HttpClient,
    private renderer: Renderer2
  ) {
  }

  hidden: boolean = true;
  initial: boolean = true;
  preloader: boolean = true;


  ngOnInit() {
//     this.modalForm.valueChanges.subscribe(() => {
//       console.log('form changed');
//  });
  }


  onSubmit() {

    if (this.type == "confirmation") {
      this.formOutputData.emit(this.action)
      setTimeout(() => {
        this.btnAction();
      }, 800);

    } else {
      for (let item in this.modalForm.form.controls) {
        let key = this.modalForm.form.controls[item]
        key.markAsTouched({onlySelf: true});
      }


      if (this.modalForm.form.valid) {

        let data = [this.modalForm.form.value]
        this.formOutputData.emit(data)

        setTimeout(() => {
          this.btnAction();
        }, 800)

      }
    }

  }

  btnAction(action?) {


    if (this.ajax && action != "close") {
      this.http.get(this.url).subscribe((e) => {
        this.outputData.emit(e)
        this.preloader = false;
        console.log(e)
      })
    }


    if (this.hidden) {
      this.renderer.addClass(document.body, 'pannel-open');

    } else {
      this.renderer.removeClass(document.body, 'pannel-open');
    }
    this.hidden = !this.hidden;
    this.initial = false;
  }

}
